export default function slugify(string) {
  return string
    .replace(/\s/g, '-')
    .toLowerCase();
}
